"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    Documents: '',
    Chats: 'Chats/:characterId?',
    Library: 'Library',
    Account: 'Account',
};
